export default class ValidationTool {
  public static requiredAndPositiveRuleFunction(value: number | string): boolean | string {
    if (!value && value !== 0 && `${value}` !== '0') {
      return 'Required';
    } if (value < 0) {
      return 'Must be positive';
    }
    return true;
  }

  public static requiredAndBetweenRuleFunction(value: number | string, min: number, max: number, fieldName: string): boolean | string {
    if (!value && value !== 0 && `${value}` !== '0') {
      return `${fieldName} is required`;
    } if (!ValidationTool.isIntegerValue(value)) {
      return `${fieldName} is not a number`;
    } if (value as number < min || value as number > max) {
      return `${fieldName} must have a value of least ${min} and at most ${max}`;
    }
    return true;
  }

  public static isIntegerValue(value: string | number): boolean {
    return !Number.isNaN(parseInt(`${value}`, 10)) && /^-?\d+$/.test(`${value}`);
  }
}
